import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { PatientService } from '../../services/patient/patient.service';
import { DoctorService } from '../../services/doctor/doctor.service';
import { PatientModel } from '../../models/patient/patient.model';
import { DoctorModel } from '../../models/doctor/doctor.model';
import { iResponse, iResponseList } from '../../models/response/response.model';
import {BrowserStorageService} from "../../services/browser-storage/browser-storage.service";

@Component({
  selector: 'app-doctor-patients-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './doctor-patients-list.component.html',
  styleUrl: './doctor-patients-list.component.sass'
})
export class DoctorPatientsListComponent implements OnInit, OnDestroy {
  patients: PatientModel[] = [];
  doctor: DoctorModel | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private patientService: PatientService,
    private doctorService: DoctorService,
    private router: Router,
    private browserStorageService: BrowserStorageService
  ) {}

  ngOnInit(): void {
    this.getMe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getMe(): void {
    this.doctorService.getMyProfile()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: iResponse<DoctorModel>) => {
          this.doctor = response.data;
          if (this.doctor?.id) {
            this.getPatients(this.doctor.id);
          }
        },
        error: (error) => {
          console.error('Error fetching doctor profile', error);
        }
      });
  }

  private getPatients(doctorId: string): void {
    this.patientService.getPatientsForDoctorId(doctorId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: iResponseList<PatientModel>) => {
          this.patients = response.data;
        },
        error: (error) => {
          console.error('Error fetching patients', error);
        }
      });
  }

  routeToPatientFile(patient: PatientModel): void {
    this.browserStorageService.set('selectedPatient', patient);
    this.router.navigate(['patientenakte'], { state: { patient: patient } });
  }
}
